import React, { PureComponent } from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'
import ApiCatalog from '../../components/ApiCatalog'
import { isAuthenticated, logout } from '../../services/self'
import { getCatalog, fetchSubscriptions } from '../../services/api-catalog'
import { Link } from 'react-router-dom'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'


export default class ApisPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}

    getCatalog().then(catalog => {
      this.setState({ catalog })
    })

    if (isAuthenticated()) {
      fetchSubscriptions().then(subscriptions => {
        this.setState({ subscriptions })
      })
    }
  }

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }

  render() {
    return (<div>
      <div>
        <div className="Logo">
          <a className="Img-Link" href="#"><Link className="home-link" to='/'><img src={logo} className="App-logo" alt="logo" /></Link></a>
          <a className="Developer-link" href="#"><Link className="home-link" to='/'>Developer</Link></a>
        </div>

        <div className="Navbar-Div">
          <nav className="App-navbar">


            <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
            <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
            <Link className="Centered-link" to='/documentation'>Docs</Link>
            <Link className="Centered-link" to='/tools'>Tools</Link>
            <Link className="Centered-link" to='/community'>Community</Link>


            {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
            <div className="right">
              {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
              {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
            </div>

            {isAuthenticated() ? '' : (
            <span className="right">
            <SignIn className="right" />
            <Register className="right-link" />
            </span>
            )}


          </nav>
        </div>
      </div>
      <div className="App-banner">

         Newforma World 2018 | October 2 - 5, 2018 | Connecting People, Projects and Information!

      </div>


<div className="main-content">

      <div> <span className="spanSpace"><p className="paraSpace"></p></span></div>
      <span className="cardSpan">
      {this.state.catalog && (!isAuthenticated() || this.state.subscriptions) ? <ApiCatalog catalog={this.state.catalog} /> : (<Dimmer active>
        <Loader content='Loading' />
      </Dimmer>)}
    </span>
  </div>
    </div>)
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Apis/index.js
 **/